import {
    Component
} from '@angular/core';

@Component({
    selector: 'store-list',
    templateUrl: 'store-list.component.html',
    host: { 'class': 'store-list component' }
})
export class StoreListComponent {
    items: any[] = [
        {
            description: 'Just a dress and a girl 0',
            imageUrls: [
                'http://i1.adis.ws/i/boohooamplience/azz03030_black_xl?$product_page_main_magic_zoom$',
                'https://www.moochi.co.nz/media/product/a90/arise-dress-navy-mrarisedress12pcd60p-navy.jpg'
            ]
        }, {
            description: 'Just a dress and a girl 1',
            imageUrls: [
                'https://images.urbanoutfitters.com/is/image/UrbanOutfitters/43241405_069_b?$xlarge$&hei=900&qlt=80&fit=constrain',
                'https://www.modcloth.com/dw/image/v2/ABAT_PRD/on/demandware.static/-/Sites-modcloth-master/default/dw4b228c89/images/10090736_PNKFL_MAIN.jpg?sw=913&sh=1304&sm=fit'
            ]
        }, {
            description: 'Just a dress and a girl 2',
            imageUrls: [
                'https://www.modcloth.com/dw/image/v2/ABAT_PRD/on/demandware.static/-/Sites-modcloth-master/default/dwcfe29440/images/10099213_PERSM_MAIN.jpg?sw=913&sh=1304&sm=fit'
            ]
        }, {
            description: 'Just a dress and a girl 3',
            imageUrls: [
                'https://images.express.com/is/image/expressfashion/0094_07851534_0001?cache=on&wid=361&fmt=jpeg&qlt=75,1&resmode=sharp2&op_usm=1,1,5,0&defaultImage=Photo-Coming-Soon'
            ]
        }, {
            description: 'Just a dress and a girl 4',
            imageUrls: [
                'https://images.express.com/is/image/expressfashion/0094_07800749_0280?cache=on&wid=361&fmt=jpeg&qlt=75,1&resmode=sharp2&op_usm=1,1,5,0&defaultImage=Photo-Coming-Soon'
            ]
        }, {
            description: 'Just a dress and a girl 5',
            imageUrls: [
                'https://media.missguided.com/s/missguided/DE904275_set/1/choker-maxi-dress-red'
            ]
        }, {
            description: 'Just a dress and a girl 6',
            imageUrls: [
                'https://cdn-images.prettylittlething.com/0/2/c/9/02c92e3a967051740e913faa030764d31b421859_clr5644_1_11.jpg'
            ]
        }, {
            description: 'Just a dress and a girl 7',
            imageUrls: [
                'https://cdn-4.jjshouse.com/upimg/jjshouse/s1140/d7/74/cb153b2a90fcec16215027a22fe1d774.jpg'
            ]
        }, {
            description: 'Just a dress and a girl 8',
            imageUrls: [
                'http://i1.adis.ws/i/boohooamplience/dzz81945_black_xl?$product_page_main_magic_zoom$'
            ]
        }, {
            description: 'Just a dress and a girl 9',
            imageUrls: [
                'https://media.missguided.com/s/missguided/DE913501_set/1/grey-one-shoulder-maxi-dress'
            ]
        }, {
            description: 'Just a dress and a girl 10',
            imageUrls: [
                'http://i1.adis.ws/i/boohooamplience/azz03030_black_xl?$product_page_main_magic_zoom$',
                'https://www.moochi.co.nz/media/product/a90/arise-dress-navy-mrarisedress12pcd60p-navy.jpg'
            ]
        }, {
            description: 'Just a dress and a girl 11',
            imageUrls: [
                'https://images.urbanoutfitters.com/is/image/UrbanOutfitters/43241405_069_b?$xlarge$&hei=900&qlt=80&fit=constrain',
                'https://www.modcloth.com/dw/image/v2/ABAT_PRD/on/demandware.static/-/Sites-modcloth-master/default/dw4b228c89/images/10090736_PNKFL_MAIN.jpg?sw=913&sh=1304&sm=fit'
            ]
        }, {
            description: 'Just a dress and a girl 12',
            imageUrls: [
                'https://www.modcloth.com/dw/image/v2/ABAT_PRD/on/demandware.static/-/Sites-modcloth-master/default/dwcfe29440/images/10099213_PERSM_MAIN.jpg?sw=913&sh=1304&sm=fit'
            ]
        }, {
            description: 'Just a dress and a girl 13',
            imageUrls: [
                'https://images.express.com/is/image/expressfashion/0094_07851534_0001?cache=on&wid=361&fmt=jpeg&qlt=75,1&resmode=sharp2&op_usm=1,1,5,0&defaultImage=Photo-Coming-Soon'
            ]
        }, {
            description: 'Just a dress and a girl 14',
            imageUrls: [
                'https://images.express.com/is/image/expressfashion/0094_07800749_0280?cache=on&wid=361&fmt=jpeg&qlt=75,1&resmode=sharp2&op_usm=1,1,5,0&defaultImage=Photo-Coming-Soon'
            ]
        }, {
            description: 'Just a dress and a girl 15',
            imageUrls: [
                'https://media.missguided.com/s/missguided/DE904275_set/1/choker-maxi-dress-red'
            ]
        }, {
            description: 'Just a dress and a girl 16',
            imageUrls: [
                'https://cdn-images.prettylittlething.com/0/2/c/9/02c92e3a967051740e913faa030764d31b421859_clr5644_1_11.jpg'
            ]
        }, {
            description: 'Just a dress and a girl 17',
            imageUrls: [
                'https://cdn-4.jjshouse.com/upimg/jjshouse/s1140/d7/74/cb153b2a90fcec16215027a22fe1d774.jpg'
            ]
        }, {
            description: 'Just a dress and a girl 18',
            imageUrls: [
                'http://i1.adis.ws/i/boohooamplience/dzz81945_black_xl?$product_page_main_magic_zoom$'
            ]
        }, {
            description: 'Just a dress and a girl 19',
            imageUrls: [
                'https://media.missguided.com/s/missguided/DE913501_set/1/grey-one-shoulder-maxi-dress'
            ]
        }
    ];

    filterResult: any[] = this.items;

    navigate(): void {
        location.reload();
    }

    onItemClick(e: any): void {
        console.log(e);
    }

    filter(value: string): void {
        this.filterResult = this.items.filter((element, index, array) => { return (element.description as string).includes(value) })
    }
}



// WEBPACK FOOTER //
// ./client-src/app/eStore/components/store-list/store-list.component.ts